import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import Colors from '../../../assets/styles/Colors'
import Loader from '../../../components/Loader'
import { useAppDispatch, useAppSelector } from '../../../store'
import { TravelAbroadState, setRegion } from '../../../store/travelAbroadSlice'
import HorizontalCard from '../../../components/v2/HorizontalCard'
import InfoMessage from '../../../components/v2/InfoMessage'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import { AppState } from '../../../store/appSlice'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { Helmet } from 'react-helmet-async'
//
//
const SelectRegion = () => {
  //
  //
  // travel regions query
  const { data: travelRegions, isLoading: isTravelRegionsLoading } = api.useGetTravelRegionsQuery(undefined)
  //
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  //
  const { t } = useTranslation()
  //
  //
  const navigate = useNavigate()
  //
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  //
  const [getLeftCompanies, { data: leftCompanies }] = api.useTravelAbrodLeftCompaniesMutation()
  //
  useEffect(() => {
    if (
      filter.productCategory &&
      filter.singleOrMulti &&
      filter.region &&
      filter.region &&
      ((filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days) ||
        (filter.singleDates?.start && filter.singleDates?.end))
    ) {
      const GetCompaniesFunction = async () => {
        try {
          //
          await getLeftCompanies({
            step: 'step-three',
            productCategory: filter.productCategory,
            startDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.start as string)
                : (filter.multiDates?.start as string),
            endDate:
              filter.singleOrMulti === 'single-travel'
                ? (filter.singleDates?.end as string)
                : (filter.multiDates?.end as string),
            multiDay: filter.singleOrMulti === 'single-travel' ? null : (filter.multiDays?.days as number),
            travelType: filter.singleOrMulti,
            area: filter.region,
          }).unwrap()
        } catch (error: any) {
          if (error?.data?.errors?.constructor === Array) {
            const firstError = error.data.errors[0]
            const errorMessage = firstError.message
            toast.error(errorMessage)
          } else {
            toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (getLeftCompanies) (SelectRegion)')
          }
        }
      }
      //
      GetCompaniesFunction()
    }

    return () => {}
  }, [
    filter.productCategory,
    filter.singleOrMulti,
    filter.multiDates?.start,
    filter.multiDates?.end,
    filter.multiDays?.days,
    filter.region,
    filter.singleDates?.start,
    filter.singleDates?.end,
    getLeftCompanies,
  ])
  //
  //
  return isTravelRegionsLoading ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('travelAreaTitle')}</title>
        <meta name="description" content={`${t('travelAreaTitle')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('travelAreaTitle')} />
        <AbroadProgressBar stepName={`${t('area')}`} />

        <Cards>
          {travelRegions &&
            travelRegions?.map((item, index) => {
              return (
                <HorizontalCard
                  className="horizontal-card"
                  key={index}
                  title={item?.translations?.[lang]?.title || ''}
                  description={item?.translations?.[lang]?.body || ''}
                  imgUrl={item?.image}
                  selected={item.type === filter.region ? true : false}
                  onClick={() => dispatch(setRegion(item.type))}
                />
              )
            })}

          {filter.region && (
            <InfoMessage
              style={{
                maxWidth: '464px',
              }}
              background="gray"
              variant="info"
              title={travelRegions?.find((x) => x.type === filter.region)?.translations?.[lang]?.title}
              text={travelRegions?.find((x) => x.type === filter.region)?.translations?.[lang]?.excerpt}
            />
          )}

          <RemainingCompanies
            style={{
              opacity: leftCompanies ? '1' : '0',
            }}
            text={`${t('offerAvailable')}: ${leftCompanies?.length} `}
          />
        </Cards>

        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [
              filter.singleOrMulti === 'single-travel'
                ? navigate('/single-select-date')
                : navigate('/multi-select-date'),
            ]}
          />
          <NavigationButton
            text={`${t('next')}`}
            buttonType="next"
            disabled={
              filter.productCategory &&
              filter.singleOrMulti &&
              filter.region &&
              leftCompanies &&
              leftCompanies.length >= 1 &&
              ((filter.multiDates?.start && filter.multiDates?.end && filter.multiDays?.days) ||
                (filter.singleDates?.start && filter.singleDates?.end))
                ? false
                : true
            }
            onClick={() => navigate('/currency-and-limit')}
          />
        </Buttons>
      </Content>

      <BackgroundIcon />
    </Wrapper>
  )
}
//

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Cards = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  width: fit-content;
  margin-inline: auto;

  .rich-text {
    font-size: 14px !important;
  }

  .horizontal-card {
    margin-bottom: 24px;
    &:last-child {
      margin-bottom: 0px;
    }
  }

  ${Responsive.mobile} {
    margin-top: 24px;

    .horizontal-card {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  z-index: 2;
  padding-inline: 20px;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
  /*  */
`
//
export default SelectRegion
